<template>
    <v-container fluid class="primary" style="min-height:700px;">

        <v-container class="mt-4">
            <!--Introduction-->
            <v-row class="mt-12 d-flex align-center">
                <v-col md=7 cols="12">

                    <h1 class="fifth--text font-weight-bold display-2">
                        5th year Computer Science Student
                        </h1>
                    <!--subtitle-->
                    <div>
                        <p class="mt-4 fifth--text font-weight-thin display-1">
                            Self-driven, determined, leader
                        </p>
                    </div>
                    <!--Languages-->
                    <div class="mb-4">
                        <span class="secondary fifth--text font-weight-bold title pa-1 pl-4 pr-4" style="border-radius:0 8px 8px 0;">
                            React.js, Vue.js, Node.js, Express.js
                        </span>
                    </div>
                    <div class="mb-4">
                        <span class="fourth fifth--text font-weight-bold title pa-1 pl-4 pr-4" style="border-radius:0 8px 8px 0;">
                            SQL / MySQL, NoSQL / GCP
                        </span>
                    </div>
                    <div class="">
                        <span class="third fifth--text font-weight-bold title pa-1 pl-4 pr-4" style="border-radius:0 8px 8px 0;">
                            Java, TypeScript
                        </span>
                    </div>
                    
                </v-col>
                <v-col offset-md="1" md=4 cols="12" class="d-flex justify-center">
                    <v-card flat class="primary" style="border-radius:8px;">
                        <v-img
                        contain
                        height="500"
                        style="border-radius:16px;"
                        src="./../assets/Me2021v4.jpg"
                        />
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

    </v-container>



</template>

<script>
export default {
    data: ()=> {
        return {
            
        }
    }
}
</script>

<style>

</style>